import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from '../../enums/url-connection.enum';
import { HttpService } from '../http-service/http.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {

    constructor(private httpService: HttpService) { }

    async getDashboardInfo(params?: any){
          return new Promise((resolve, reject) => {
              try {

                  let config = this.httpService.setHeaderConfig(true);

                  // Construir query params se fornecidos
                  let queryParams = {};
                  if (params) {
                    queryParams = {
                      dataInicio: params.dataInicio,
                      dataFim: params.dataFim,
                      status: params.status,
                      ufs: params.ufs,
                      kits: params.kits
                    };
                  }

                  this.httpService.get(UrlConnectionEnum.GET_DASHBOARD, queryParams, config).subscribe({
                      next: (data) => {
                          if(data.result){
                              resolve(data);
                          }else{
                            resolve(data)
                          }
                      },
                      error: (error) => {
                          reject(error);
                      }
                  });

              } catch (error) {
                  reject(error);
              }
          });
    }

    async getDashboardAccumulated(){
        return new Promise((resolve, reject) => {
          try {
            let config = this.httpService.setHeaderConfig(true);
            this.httpService.get(UrlConnectionEnum.GET_DASHBOARD_ACCUMULATED, {}, config).subscribe({
              next: (data) => {
                if(data.result){
                  resolve(data);
                }else{
                  resolve(data)
                }
              },
              error: (error) => {
                reject(error);
              }
            });
          } catch (error) {
            reject(error);
          }
        });
    }

}
